import styles from "@/components/sidebar-shell.module.css";
import * as signals from "@/signals";
import { handleKeyboardClick } from "@/utils";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { t } from "i18next";
import { JSX } from "react";

interface SidebarShellProps {
	children: JSX.Element;
	onClose: () => void | Promise<void>;
	title: JSX.Element;
}

function SidebarShell({
	children,
	onClose,
	title,
}: SidebarShellProps): JSX.Element {
	const handleClose = (): void => {
		void onClose();
	};

	return (
		<div
			className={clsx(
				styles["sidebar"],
				!signals.isClosingSidebar.value && "slide-in",
				signals.isClosingSidebar.value && "slide-out",
			)}
		>
			<div className={styles["title-bar"]}>
				<div className="with-icon">{title}</div>
				<div
					className={styles["close-button"]}
					role="button"
					tabIndex={0}
					title={t("close")}
					onClick={handleClose}
					onKeyDown={handleKeyboardClick(handleClose)}
				>
					<FontAwesomeIcon
						icon={faXmark}
						size="lg"
					/>
				</div>
			</div>
			<>{children}</>
		</div>
	);
}

export default SidebarShell;
